export const MANAGESERVICE = 'MANAGESERVICE'